const styles = (theme) => ({
  container: {
    p: { xs: 2, md: 4 },
    maxWidth: "100%",
    margin: "0 auto",
  },
  paperContainer: {
    p: { xs: 2, md: 2.5 },
    mb: 3,
    borderRadius: 3,
  },
  title: {
    mb: 3,
    fontWeight: 500,
  },
  searchBarContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
    alignItems: { xs: "stretch", md: "center" },
  },
  searchTextField: {
    "& .MuiOutlinedInput-root": { borderRadius: 2 },
  },
  filterButton: {
    whiteSpace: "nowrap",
    borderRadius: 2,
    height: 40,
  },
  filtersWrapper: {
    mt: 2.5,
    p: 2.5,
    borderRadius: 2,
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  },
  filterActionsContainer: {
    display: "flex",
    gap: 1,
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    p: 6,
  },
  resultsContainer: {
    mt: 2.5,
  },
  mobileCardsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  mobileCard: {
    borderRadius: 3,
    bgcolor: "background.paper",
  },
  mobileCardContent: {
    pb: "16px !important",
  },
  mobileCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: 1.5,
  },
  mobileStatusChip: {
    fontWeight: "700",
    fontSize: "0.65rem",
    borderRadius: 1.5,
  },
  mobileClientName: {
    mb: 0.5,
  },
  mobileServiceName: {
    mb: 1.5,
  },
  divider: {
    my: 1.5,
  },
  mobileDescription: {
    mt: 0.5,
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 3,
  },
  mobileCardFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    mt: 2,
  },
  autocompleteFilter: {
    "& .MuiAutocomplete-tag": {
      maxWidth: "calc(100% - 90px)", // Limita a tag para deixar espaç
      pointerEvents: "none",
    },
    // 2. Reativa os eventos de clique APENAS no ícone de excluir (X) da tag
    "& .MuiChip-deleteIcon": {
      pointerEvents: "auto",
    },
  },
  conatinerLoading: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    bgcolor: "background.paper",
    boxShadow: 24,
    height: "700px",
    maxHeight: "90vh",
    overflowY: "auto",
  },
  mobileAvatarGroup: {
    cursor: "pointer",
    "& .MuiAvatar-root": {
      width: 28,
      height: 28,
      fontSize: 12,
    },
  },
  noTicketsTextMobile: {
    py: 4,
  },
  tableContainer: {
    borderRadius: 3,
    overflow: "hidden",
    bgcolor: theme.palette.background.paper,
  },
  table: {
    minWidth: 900,
  },
  tableCellProtocolo: {
    py: 2,
  },
  tableCellClientText: {
    maxWidth: 260,
    fontWeight: 600,
  },
  tableCellServiceText: {
    maxWidth: 260,
    display: "block",
    mt: 0.5,
  },
  tableCellTipoText: {
    fontSize: "0.825rem",
    fontWeight: 500,
  },
  tableCellDescricaoText: {
    maxWidth: 240,
    display: "block",
    cursor: "pointer",
    mt: 0.5,
  },
  tableCellStatusChip: {
    fontWeight: "700",
    fontSize: "0.675rem",
    borderRadius: 1.5,
  },
  tableCellCenterBox: {
    display: "flex",
    justifyContent: "center",
  },
  tableCellAvatarBox: {
    p: 0.5,
  },
  tableCellAvatarGroup: {
    cursor: "pointer",
    "& .MuiAvatar-root": {
      width: 30,
      height: 30,
      fontSize: 13,
    },
  },
  verTicketButton: {
    whiteSpace: "nowrap",
  },
  noTicketsTableCell: {
    py: 5,
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "flex-end",
    mt: { xs: 2, lg: 0 },
  },
  tooltipContainer: {
    p: 0.5,
    maxWidth: "300px",
  },
  tooltipTitle: {
    mb: 0.5,
  },
  tooltipItem: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "300px",
  },
});

export default styles;
